import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'
import Actions from 'reports/scrapTrend/actions'
import navigation from 'containers/Navigation/reducer'
import { allById, allIds, customById, idsByCustomCollection } from 'lib/reducers'

const config = handleActions(
  {
    [Actions.SET_TOKEN]: (state, { payload: token }) => ({ ...state, token })
  },
  { token: null, locale: null, timezone: null }
)

const init = handleActions(
  {
    [Actions.START_INIT]: state => ({ ...state, isFinished: false }),
    [Actions.FINISH_INIT]: state => ({ ...state, isFinished: true })
  },
  { isFinished: false }
)

const plant = handleActions({}, { name: '' })

const reports = handleActions(
  {
    [Actions.RECEIVE_REPORTS]: (state, { payload }) => payload
  },
  []
)

const locations = handleActions(
  {
    [Actions.RECEIVE_LOCATIONS]: (state, { payload: locations }) => ({
      allById: allById(locations),
      allIds: allIds(locations),
      isVisibleById: customById(locations, true)
    }),
    [Actions.SHOW_LOCATION]: (state, { payload: { value: id } }) => ({
      ...state,
      isVisibleById: { ...state.isVisibleById, [id]: true }
    }),
    [Actions.HIDE_LOCATION]: (state, { payload: { value: id } }) => ({
      ...state,
      isVisibleById: { ...state.isVisibleById, [id]: false }
    }),
    [Actions.SHOW_ALL_LOCATIONS]: state => ({
      ...state,
      isVisibleById: state.allIds.reduce((acc, val) => {
        acc[val] = true
        return acc
      }, {})
    }),
    [Actions.HIDE_ALL_LOCATIONS]: state => ({
      ...state,
      isVisibleById: state.allIds.reduce((acc, val) => {
        acc[val] = false
        return acc
      }, {})
    })
  },
  { allIds: [], isVisibleById: {}, allById: {} }
)

const products = handleActions(
  {
    [Actions.RECEIVE_PRODUCTS]: (state, { payload: products }) => ({
      allById: allById(products),
      allIds: allIds(products),
      isVisibleById: customById(products, true),
      idsByLocation: idsByCustomCollection(products, 'locationIds')
    }),
    [Actions.SHOW_PRODUCT]: (state, { payload: { value: id } }) => ({
      ...state,
      isVisibleById: { ...state.isVisibleById, [id]: true }
    }),
    [Actions.HIDE_PRODUCT]: (state, { payload: { value: id } }) => ({
      ...state,
      isVisibleById: { ...state.isVisibleById, [id]: false }
    }),
    [Actions.SHOW_ALL_PRODUCTS]: state => ({
      ...state,
      isVisibleById: state.allIds.reduce((acc, val) => {
        acc[val] = true
        return acc
      }, {})
    }),
    [Actions.HIDE_ALL_PRODUCTS]: state => ({
      ...state,
      isVisibleById: {}
    })
  },
  { allIds: [], isVisibleById: {}, allById: {} }
)

const projects = handleActions(
  {
    [Actions.RECEIVE_PROJECTS]: (state, { payload: projects }) => ({
      allById: allById(projects),
      allIds: allIds(projects),
      isVisibleById: customById(projects, true),
      idsByLocation: idsByCustomCollection(projects, 'locationIds')
    }),
    [Actions.SHOW_PROJECT]: (state, { payload: { value: id } }) => ({
      ...state,
      isVisibleById: { ...state.isVisibleById, [id]: true }
    }),
    [Actions.HIDE_PROJECT]: (state, { payload: { value: id } }) => ({
      ...state,
      isVisibleById: { ...state.isVisibleById, [id]: false }
    }),
    [Actions.SHOW_ALL_PROJECTS]: state => ({
      ...state,
      isVisibleById: state.allIds.reduce((acc, val) => {
        acc[val] = true
        return acc
      }, {})
    }),
    [Actions.HIDE_ALL_PROJECTS]: state => ({
      ...state,
      isVisibleById: {}
    })
  },
  { allIds: [], isVisibleById: {}, allById: {} }
)

export default combineReducers({
  config,
  init,
  plant,
  navigation,
  reports,
  locations,
  products,
  projects
})
